import { io } from "socket.io-client";
import React from "react";
import { SERVER_URL } from "../api/HttpRequest";

export const socket = io(SERVER_URL, {
  transports: ["websocket"],
});
export const SocketContext = React.createContext();
